import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _mutations;
import "core-js/modules/es.object.assign.js";
import axios from 'axios';
import { API_GET_HOTSHOP_LIST } from '@/apis';
import * as MT from '@/constants/venues';
export default {
  state: {
    hotShopList: [],
    paging: {
      pageNo: 1,
      pageSize: 20,
      hasMore: true,
      totalHits: 0
    },
    performanceNumber: 4,
    loading: false,
    dataError: false
  },
  actions: _defineProperty({}, MT.GET_HOTSHOP_LISTS, function (_ref) {
    var commit = _ref.commit,
      state = _ref.state;
    var _state$paging = state.paging,
      pageNo = _state$paging.pageNo,
      pageSize = _state$paging.pageSize,
      hasMore = _state$paging.hasMore,
      loading = state.loading,
      performanceNumber = state.performanceNumber;
    if (loading || !hasMore) return;
    commit(MT.SET_HOTSHOP_STATUS, {
      err: false,
      loading: true
    });
    axios.get(API_GET_HOTSHOP_LIST, {
      params: {
        pageNo: pageNo,
        pageSize: pageSize,
        performanceNumber: performanceNumber
      }
    }).then(function (_ref2) {
      var code = _ref2.code,
        data = _ref2.data,
        paging = _ref2.paging;
      commit(MT.SET_HOTSHOP_STATUS, {
        err: code !== 200,
        loading: false
      });
      if (code === 200) {
        commit(MT.SET_HOTSHOP_LIST, data);
        commit(MT.SET_HOTSHOP_PAGING, paging);
      }
    }).catch(function (err) {
      console.warn(err);
    });
  }),
  mutations: (_mutations = {}, _defineProperty(_mutations, MT.SET_HOTSHOP_LIST, function (state, list) {
    var _state$hotShopList;
    (_state$hotShopList = state.hotShopList).push.apply(_state$hotShopList, _toConsumableArray(list));
  }), _defineProperty(_mutations, MT.SET_HOTSHOP_PAGING, function (state, paging) {
    ++paging.pageNo;
    Object.assign(state.paging, paging);
  }), _defineProperty(_mutations, MT.SET_HOTSHOP_STATUS, function (state, _ref3) {
    var _ref3$err = _ref3.err,
      err = _ref3$err === void 0 ? false : _ref3$err,
      loading = _ref3.loading;
    state.dataError = err;
    state.loading = loading;
  }), _mutations),
  getters: {
    hotShopListData: function hotShopListData(state) {
      return state;
    }
  }
};